import React, { useState } from "react";
import axiosInstance from "../../axios/axios";
import vozoLogo from "../../assets/images/vozo-logo-1.png";
import { Encrypt_Value, Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { Input, Select, DatePicker } from "antd";
import { HiOutlineTrash } from "react-icons/hi";
import moment from "moment";

const dtFormat = "MM/DD/YYYY";

const LICENSE_TYPES = [
  "MD",
  "DO",
  "NP",
  "PA",
  "CRNA",
  "CNM",
  "CNS",
  "RN",
  "LPN/LVN",
  "PT",
  "OT",
  "SLP",
  "RT",
  "RD",
  "PhD/PsyD",
  "LCSW",
  "LMFT",
  "LPC/LPCC",
  "BCBA",
  "CMA",
  "CNA",
  "RRT",
  "RT,ARRT",
  "MLS/MT/CLT/MLT",
  "PharmD",
  "RPh",
  "CPhT",
  "DC",
  "DPM",
  "DDS/DMD",
  "OD",
  "AuD",
  "LMHC",
  "LCPC",
  "LICSW",
  "LMSW",
];

const regionsData = [
  {
    label: "-US-",
    options: [
      { value: "AL", title: "Alabama" },
      { value: "AK", title: "Alaska" },
      { value: "AZ", title: "Arizona" },
      { value: "AR", title: "Arkansas" },
      { value: "CA", title: "California" },
      { value: "CO", title: "Colorado" },
      { value: "CT", title: "Connecticut" },
      { value: "DE", title: "Delaware" },
      { value: "DC", title: "District of Columbia" },
      { value: "FL", title: "Florida" },
      { value: "GA", title: "Georgia" },
      { value: "HI", title: "Hawaii" },
      { value: "ID", title: "Idaho" },
      { value: "IL", title: "Illinois" },
      { value: "IN", title: "Indiana" },
      { value: "IA", title: "Iowa" },
      { value: "KS", title: "Kansas" },
      { value: "KY", title: "Kentucky" },
      { value: "LA", title: "Louisiana" },
      { value: "ME", title: "Maine" },
      { value: "MD", title: "Maryland" },
      { value: "MA", title: "Massachusetts" },
      { value: "MI", title: "Michigan" },
      { value: "MN", title: "Minnesota" },
      { value: "MS", title: "Mississippi" },
      { value: "MO", title: "Missouri" },
      { value: "MT", title: "Montana" },
      { value: "NE", title: "Nebraska" },
      { value: "NV", title: "Nevada" },
      { value: "NH", title: "New Hampshire" },
      { value: "NJ", title: "New Jersey" },
      { value: "NM", title: "New Mexico" },
      { value: "NY", title: "New York" },
      { value: "NC", title: "North Carolina" },
      { value: "ND", title: "North Dakota" },
      { value: "OH", title: "Ohio" },
      { value: "OK", title: "Oklahoma" },
      { value: "OR", title: "Oregon" },
      { value: "PA", title: "Pennsylvania" },
      { value: "PR", title: "Puerto Rico" },
      { value: "RI", title: "Rhode Island" },
      { value: "SC", title: "South Carolina" },
      { value: "SD", title: "South Dakota" },
      { value: "TN", title: "Tennessee" },
      { value: "TX", title: "Texas" },
      { value: "UT", title: "Utah" },
      { value: "VT", title: "Vermont" },
      { value: "VA", title: "Virginia" },
      { value: "WA", title: "Washington" },
      { value: "WV", title: "West Virginia" },
      { value: "WI", title: "Wisconsin" },
      { value: "WY", title: "Wyoming" },
    ],
  },
  {
    label: "-CA-",
    options: [
      { value: "AB", title: "Alberta" },
      { value: "BC", title: "British Columbia" },
      { value: "MB", title: "Manitoba" },
      { value: "NB", title: "New Brunswick" },
      { value: "NL", title: "Newfoundland and Labrador" },
      { value: "NT", title: "Northwest Territories" },
      { value: "NS", title: "Nova Scotia" },
      { value: "NU", title: "Nunavut" },
      { value: "ON", title: "Ontario" },
      { value: "PE", title: "Prince Edward Island" },
      { value: "QC", title: "Quebec" },
      { value: "SK", title: "Saskatchewan" },
      { value: "YT", title: "Yukon" },
    ],
  },
];
const getUserId = () => {
  try {
    const encryptedId = localStorage.getItem("user_id");
    if (!encryptedId) return null;
    return Decrypt_Value(encryptedId, "vozo");
  } catch (e) {
    console.error("User ID decrypt failed", e);
    return null;
  }
};

const updateOnboardingStep = async (step) => {
  const userId = getUserId();
  if (!userId) return;

  try {
    const payload = Encrypt_Value({ uid: userId, step: step }, "vozo");

    await axiosInstance.post("/vozo/updatepopupstep", payload);
  } catch (err) {
    console.error("Onboarding step update failed", err);
  }
};

const emptyLicense = {
  license_type: "",
  license_no: "",
  license_expiry: "",
  license_state: "",
};

const fetchExistingLicenses = async (userId) => {
  if (!userId) return [];

  const res = await axiosInstance.get(`/vozo/sclinicallicence?uid=${userId}`);

  return Decrypt_Value(res.data, "vozo") || [];
};
const mergeLicenses = (existing, incoming) => {
  const map = new Map();

  [...existing, ...incoming].forEach((l) => {
    const state = l.licenseState || l.state;
    const num = l.licensenum || l.license_number;
    const type = l.licentype || l.license_type;
    const key = `${state}-${num}-${type}`;
    map.set(key, l);
  });

  return Array.from(map.values());
};

const ClinicalPopupFields = ({ onSkip, onSuccess }) => {
  const [licenseErrors, setLicenseErrors] = useState({});
  const [duplicateIndex, setDuplicateIndex] = useState(-1);

  const [licenses, setLicenses] = useState([emptyLicense]);

  const [form, setForm] = useState({
    npi_number: "",
    taxonomy_code: "",
  });

  const updateLicense = (index, field, value) => {
    const updated = [...licenses];
    updated[index] = { ...updated[index], [field]: value };
    setLicenses(updated);
  };

  const addLicense = () => {
    setLicenses([
      ...licenses,
      {
        license_type: "",
        license_no: "",
        license_expiry: "",
        license_state: "",
      },
    ]);
  };
  const removeLicense = (index) => {
    const updated = [...licenses];
    updated.splice(index, 1);
    setLicenses(updated);
  };

  const validateLicenses = () => {
    setDuplicateIndex(-1);
    let errors = {};
    let seen = new Set();

    for (let i = 0; i < licenses.length; i++) {
      const l = licenses[i];

      const hasAnyValue =
        l.license_type || l.license_no || l.license_expiry || l.license_state;

      if (!hasAnyValue) continue;

      if (!l.license_type) errors[i] = "License Type required";
      else if (!l.license_no) errors[i] = "License Number required";
      else if (!l.license_expiry) errors[i] = "License Expiry required";
      else if (!l.license_state) errors[i] = "License State required";

      const key = `${l.license_state
        ?.trim()
        .toUpperCase()}-${l.license_no?.trim()}-${l.license_type
        ?.trim()
        .toUpperCase()}`;

      if (seen.has(key)) {
        setDuplicateIndex(i);
        return false;
      }
      seen.add(key);
    }

    setLicenseErrors(errors);
    setDuplicateIndex(-1);
    return Object.keys(errors).length === 0;
  };

  const isClinicalValid = () => {
    const l = licenses[0];

    const licenseTypeValid = l.license_type && l.license_type.trim() !== "";
    const licenseNoValid = l.license_no && l.license_no.trim() !== "";
    const expiryValid = l.license_expiry && l.license_expiry.trim() !== "";
    const stateValid = l.license_state && l.license_state.trim() !== "";

    const npiValid = form.npi_number && form.npi_number.trim().length === 10;

    return (
      licenseTypeValid &&
      licenseNoValid &&
      expiryValid &&
      stateValid &&
      npiValid
    );
  };

  const handleSave = async () => {
    // if (!validateLicenses()) return;

    const userId = getUserId();
    if (!userId) {
      console.warn("User not logged in");
      return;
    }

    try {
      const existingLicenses = await fetchExistingLicenses(userId);

      const newLicenses = licenses
        .filter(
          (l) =>
            l.license_type ||
            l.license_no ||
            l.license_expiry ||
            l.license_state,
        )
        .map((l) => ({
          licentype: l.license_type,
          licensenum: l.license_no,
          licenseExp: l.license_expiry,
          licenseState: l.license_state,
        }));

      const mergedLicenses = mergeLicenses(existingLicenses, newLicenses);

      const payload = {
        uid: userId,
        npinum: form.npi_number,
        taxonomy: form.taxonomy_code,
        license: mergedLicenses,
      };

      const encryptedData = Encrypt_Value(payload, "vozo");
      await axiosInstance.put("/sclinical-onboarding", encryptedData);

      await updateOnboardingStep(2);

      onSuccess();
    } catch (err) {
      console.error("Clinical save failed", err);
    }
  };

  return (
    <div
      className="acp-step acp-clinical-step"
      style={{
        maxHeight: "85vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ flexShrink: 0 }}>
        <img src={vozoLogo} alt="VOZO" className="acp-logo" />

        <h3 className="acp-title">Complete your clinical profile</h3>
        <p className="acp-desc">
          Add Licenses and Clinical Information to Complete Your Profile.
        </p>
      </div>
      <div
        style={{
          overflowY: "auto",
          paddingRight: 8,
          marginTop: 5,
        }}
      >
        <h4 className="acp-section-title">Licenses</h4>

        {licenses.map((lic, i) => (
          <div
            key={i}
            className="acp-grid"
            style={{
              marginBottom: 22,
              position: "relative",
            }}
          >
            <div>
              <label>
                License Type <span className="req-star">*</span>
              </label>
              <Select
                value={lic.license_type || undefined}
                placeholder="Select"
                style={{ width: "100%" }}
                onChange={(val) => updateLicense(i, "license_type", val)}
              >
                {LICENSE_TYPES.map((t) => (
                  <Select.Option key={t} value={t}>
                    {t}
                  </Select.Option>
                ))}
              </Select>
            </div>

            <div>
              <label>
                License # <span className="req-star">*</span>
              </label>
              <Input
                value={lic.license_no}
                onChange={(e) => updateLicense(i, "license_no", e.target.value)}
              />
            </div>

            <div>
              <label>
                License Expires <span className="req-star">*</span>
              </label>
              <DatePicker
                getPopupContainer={(n) => n.parentNode}
                className="w-100"
                format={dtFormat}
                value={
                  lic.license_expiry
                    ? moment(lic.license_expiry, "YYYY-MM-DD", true)
                    : null
                }
                onChange={(date) =>
                  updateLicense(
                    i,
                    "license_expiry",
                    date ? date.format("YYYY-MM-DD") : "",
                  )
                }
                allowClear={false}
              />
            </div>

            <div>
              <label>
                License State <span className="req-star">*</span>
              </label>
              <Select
                value={lic.license_state || undefined}
                placeholder="Select State"
                style={{ width: "100%" }}
                onChange={(val) => updateLicense(i, "license_state", val)}
              >
                {regionsData.map((group) => (
                  <Select.OptGroup key={group.label} label={group.label}>
                    {group.options.map((opt) => (
                      <Select.Option key={opt.value} value={opt.value}>
                        {opt.value} - {opt.title}
                      </Select.Option>
                    ))}
                  </Select.OptGroup>
                ))}
              </Select>
            </div>

            {licenses.length > 1 && (
              <div
                style={{
                  gridColumn: "1 / span 2",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 4,
                }}
              >
                <HiOutlineTrash
                  onClick={() => removeLicense(i)}
                  style={{
                    cursor: "pointer",
                    color: "#ff4d4f",
                    fontSize: 20,
                  }}
                />
              </div>
            )}
          </div>
        ))}

        <button
          type="button"
          className="acp-add-license"
          onClick={addLicense}
          style={{ marginBottom: 15 }}
        >
          + Add License
        </button>

        <h4 className="acp-section-title">Clinical Information</h4>

        <div className="acp-grid">
          <div>
            <label>
              NPI Number <span className="req-star">*</span>
            </label>
            <Input
              value={form.npi_number}
              maxLength={10}
              onChange={(e) =>
                setForm({
                  ...form,
                  npi_number: e.target.value.replace(/\D/g, ""),
                })
              }
            />
            {form.npi_number.length > 0 && form.npi_number.length !== 10 && (
              <small className="acp-error">NPI must be 10 digits</small>
            )}
          </div>

          <div>
            <label>Taxonomy Code</label>
            <Input
              value={form.taxonomy_code}
              maxLength={10}
              onChange={(e) =>
                setForm({
                  ...form,
                  taxonomy_code: e.target.value
                    .replace(/[^a-zA-Z0-9]/g, "")
                    .toUpperCase(),
                })
              }
            />
          </div>
        </div>
      </div>

      <div className="acp-footer">
        <div className="acp-progress-wrap">
          <span className="acp-progress-text">1/2</span>

          <div className="acp-progress-bars">
            <div className="acp-progress-bar">
              <div className="acp-progress-fill filled" />
            </div>

            <div className="acp-progress-bar">
              <div className="acp-progress-fill" />
            </div>
          </div>
        </div>

        <div className="acp-actions">
          <button
            className="acp-skip"
            onClick={async () => {
              await updateOnboardingStep(2);
              onSkip();
            }}
          >
            Skip for now
          </button>

          <button
            className="acp-save"
            onClick={handleSave}
            disabled={!isClinicalValid()}
            style={{
              opacity: isClinicalValid() ? 1 : 0.5,
              cursor: isClinicalValid() ? "pointer" : "not-allowed",
            }}
          >
            Save & Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClinicalPopupFields;